import { ProviderLabels } from './provider-labels';

export const labels: ProviderLabels = {
  provider: 'Billing Provider',
  environment: {
    live: 'Live',
    test: 'Test',
  },
  coupon: {
    singular: 'Coupon',
    plural: 'Coupons',
    id: 'ID',
  },
  dashboard: {
    login: 'https://churnkey.co',
  },
};
